import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Helmet1 from "./Helmet1";
import {
  Animate,
  AnimateGroup,
  useAnimateGroup,
  AnimateKeyframes,
} from "react-simple-animate";

const LoadingView = ({}) => {
  const dispatch = useDispatch();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  const [a_logo_appear, set_a_logo_appear] = React.useState(false);
  const [a_letter_fall, set_a_letter_fall] = React.useState(false);
  const [a_logo_rotate, set_a_logo_rotate] = React.useState(false);
  const [a_white_disappear, set_a_white_disappear] = React.useState(false);

  useEffect(() => {
    setTimeout(() => {
      set_a_logo_appear(true);
    }, 500);
  }, []);

  return (
    <>
      {/* <Helmet1 />
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,minimum-scale=1.0"
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <title>SC WORLD EXCHANGE</title>
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.8.1/css/all.css"
          integrity="sha384-50oBUHEmvpQ+1lW4y57PTFmhCaXp0ML5d60M1M7uH2+nqUivzIebhndOJK28anvf"
          crossorigin="anonymous"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css"
        />
        <link
          id="PreLoading"
          rel="stylesheet"
          href="/dist/css/exis.css"
          onload="$('.Helmet1').hide()"
        />
        <link
          id="PreLoading"
          rel="stylesheet"
          href="/dist/css/admin.css"
          onload="$('.Helmet1').hide()"
        />
        <link
          id="Top"
          rel="stylesheet"
          href="/dist/css/front.css"
          onload="$('.Helmet1').hide()"
        />
      </Helmet> */}
      <div
        className="d-flex justify-content-center align-items-center"
        // style={{ position: "fixed", height: "100vh", width: "100vw" ,background:"red"}}
        style={{
          position: "absolute",
          height: "100vh",
          width: "100vw",
          background: "white",
          zIndex: 1000000,
        }}
      >
        <Animate
          play={true}
          pause={false}
          easeType="ease-out"
          duration={2}
          // start={{ opacity: 0 }}
          // end={{ opacity: 1 }}
          start={{
            position: "absolute",
            top: "50%",
            left: "50%",

            marginLeft: -100,
            marginTop: -100,
            opacity: 0,
            transform: "rotateX(0) rotateY(0) rotateZ(0)",
          }}
          end={{
            position: "absolute",
            top: "50%",
            left: "50%",

            marginLeft: -100,
            marginTop: -100,
            opacity: 1,
            transform: "rotateX(0deg) rotateY(180deg) rotateZ(0deg)",
          }}
          onComplete={() => {
            set_a_white_disappear(true);
          }}
        >
          <img 
          style={{
          }}
          
          
          width={200} src="../images/brand.svg" />
        </Animate>
        {/* <div
        className="loader"
        style={{ position: "absolute", top: "50%", left: "50%", margin: 0 }}
        // style={{ position: "relative" }}
        // style={{
        //   position: "absolute",
        //   top: 0,
        //   left: 0,
        //   right: 0,
        //   bottom: 0,
        //   margin: "auto",
        // }}
      >
        Loading...
      </div> */}

        {/* // <div className="loader" style={{position:"fixed", top: "50%", left: "50%",margin:0 }}>Loading...</div> */}
        {/* // <div className="loader" style={{position:"fixed", top: "50%", left: "50%",margin:0 }}>Loading...</div> */}
      </div>
    </>
  );
};

export default LoadingView;
